"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = flexRightColumn;
function flexRightColumn() {
  return /*css*/"\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-end;\n  ";
}